import React from 'react';
import { ArrowRight, Scale, Shield, FileText, Users } from 'lucide-react';

const HeroSection = ({ onGetStarted }) => {
  return (
    <section
      className="relative pt-40 pb-20 lg:pt-48 lg:pb-28 flex items-center"
      style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1773472153650-b3398ea6d3df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsYXclMjBmaXJtJTIwb2ZmaWNlJTIwc2t5c2NyYXBlciUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3NzU1MjA1NDJ8MA&ixlib=rb-4.1.0&q=85)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
      data-testid="hero-section"
    >
      <div className="absolute inset-0 bg-[#2C3E50]/70"></div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-tight text-white font-bold mb-6" data-testid="hero-heading">
              Strategic Legal Solutions for Your Business
            </h1>
            <p className="text-lg lg:text-xl text-white/90 leading-relaxed mb-8">
              Trusted by businesses nationwide, we provide comprehensive legal expertise in corporate law, intellectual property, and compliance.
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <button
                onClick={onGetStarted}
                className="bg-[#CA9A67] text-white hover:bg-[#b8894f] transition-colors px-8 py-4 font-medium flex items-center justify-center space-x-2"
                data-testid="hero-cta-button"
              >
                <span>Get Legal Help</span>
                <ArrowRight className="w-5 h-5" />
              </button>
              <a
                href="#services"
                className="border-2 border-white text-white hover:bg-white hover:text-[#2C3E50] transition-colors px-8 py-4 font-medium text-center"
                data-testid="hero-learn-more-button"
              >
                Learn More
              </a>
            </div>
          </div>

          <div className="hidden lg:grid grid-cols-2 gap-4" data-testid="hero-practice-areas">
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 p-6 hover:bg-white/15 transition-colors">
              <Scale className="w-8 h-8 text-[#CA9A67] mb-3" strokeWidth={1.5} />
              <h3 className="text-white font-semibold mb-1">Corporate Law</h3>
              <p className="text-white/70 text-sm leading-relaxed">Contracts, formation & business transactions</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 p-6 hover:bg-white/15 transition-colors">
              <Shield className="w-8 h-8 text-[#CA9A67] mb-3" strokeWidth={1.5} />
              <h3 className="text-white font-semibold mb-1">IP Protection</h3>
              <p className="text-white/70 text-sm leading-relaxed">Trademark & copyright registration</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 p-6 hover:bg-white/15 transition-colors">
              <FileText className="w-8 h-8 text-[#CA9A67] mb-3" strokeWidth={1.5} />
              <h3 className="text-white font-semibold mb-1">Compliance</h3>
              <p className="text-white/70 text-sm leading-relaxed">Anti-corruption & regulatory guidance</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 p-6 hover:bg-white/15 transition-colors">
              <Users className="w-8 h-8 text-[#CA9A67] mb-3" strokeWidth={1.5} />
              <h3 className="text-white font-semibold mb-1">Immigration</h3>
              <p className="text-white/70 text-sm leading-relaxed">Work visas & green card services</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
